import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { classNames } from 'primereact/utils';
import { useHistory } from "react-router-dom";

const AppInlineMenu = (props) => {
    const history = useHistory();
    const [nome, setNome] = useState('');
    const [avatar, setAvatar] = useState('assets/layout/images/profile-image.png');

    useEffect(() => {
        const userProfile = JSON.parse(localStorage.getItem('profile'));

        if (userProfile) {
            setNome(userProfile.profile.name)
            let image = userProfile.profile.images.find(o => o.type.name === 'Avatar');
            if (image) setAvatar(image.url);
        }
    });


    const isSlim = () => {
        return props.menuMode === 'slim';
    }

    const isStatic = () => {
        return props.menuMode === 'static';
    }

    const isSidebar = () => {
        return props.menuMode === 'sidebar';
    }

    const isMobile = () => {
        return window.innerWidth <= 991;
    }

    const handleLogout = () => {
        // logout logic
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('profile');
        localStorage.removeItem('iss');
        localStorage.removeItem('idUser');
        localStorage.removeItem('idEmpresa');
        localStorage.removeItem('idPrestador');
        localStorage.removeItem('nomeEmpresa');
        localStorage.removeItem('lojaSelecionada');
        history.push('/login');

    }

    const handleProfile = () => {
        // logout logic
        history.push('/profile');

    }

    return (
        <>
            {!isMobile() && (isStatic() || isSlim() || isSidebar()) && <div className={classNames('layout-inline-menu', { 'layout-inline-menu-active': props.activeInlineProfile })}>
                <button className="layout-inline-menu-action p-link" onClick={props.onChangeActiveInlineMenu}>
                    <img src={avatar} alt="avatar" style={{ width: '44px', height: '44px' }} />
                    <span class="layout-inline-menu-text overflow-hidden">{nome}</span>
                    <i className="layout-inline-menu-icon pi pi-angle-down"></i>
                </button>
                <CSSTransition classNames="p-toggleable-content" timeout={{ enter: 1000, exit: 450 }} in={props.activeInlineProfile} unmountOnExit>
                    <ul className="layout-inline-menu-action-panel">
                        <li className="layout-inline-menu-action-item">
                            <button className="p-link" onClick={handleProfile}>
                                <i className="pi pi-fw pi-user"></i>
                                <span>Perfil</span>
                            </button>
                        </li>
                        <li className="layout-inline-menu-action-item">
                            <button onClick={handleLogout} className="p-link">
                                <i className="pi pi-power-off pi-fw"></i>
                                <span>Sair</span>
                            </button>
                        </li>
                    </ul>
                </CSSTransition>
            </div>}
        </>
    )
}

export default AppInlineMenu;
